(() => {
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  const key = `micro-color-return:${location.pathname}${location.search}`;

  grid.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link) return;
    sessionStorage.setItem(key, JSON.stringify({ y: window.scrollY, savedAt: Date.now() }));
  });

  const navigation = performance.getEntriesByType('navigation')[0];
  if (!navigation || navigation.type !== 'back_forward') return;
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return; }
  if (!saved || !Number.isFinite(saved.y) || Date.now() - saved.savedAt > 3600000) return;

  const deadline = Date.now() + 10000;
  const restore = () => {
    window.scrollTo(0, saved.y);
    if (Math.abs(window.scrollY - saved.y) < 4 || Date.now() >= deadline) {
      sessionStorage.removeItem(key);
      observer.disconnect();
    }
  };
  const observer = new MutationObserver(restore);
  observer.observe(grid, { childList: true, subtree: true });
  window.addEventListener('pageshow', restore, { once: true });
  window.addEventListener('load', restore, { once: true });
  requestAnimationFrame(restore);
})();
